import React from "react";
import { useTranslation } from "react-i18next";
import ErrorMessage from "./ErrorMessage";

const NoAccessPerfTesting = (props) => {
  const { t } = useTranslation();
  return (
    <ErrorMessage
      showAppBar={false}
      messageType="security"
      message={t("messages.common.errors.testingMode")}
    />
  );
};

export default NoAccessPerfTesting;
